import { IAsyncActionCreator, createAsyncActionCreator } from '../store/actions/createActionCreator';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { errorHandlerFacet } from '../facets/ConfigurationFacets';
import { readConfiguration } from './configuration/readConfiguration';

/**
 * @public
 */
export interface IHandleErrorPayload {
    error: Error;
}

/**
 * @public
 */
export const handleError: IAsyncActionCreator<IHandleErrorPayload, IItemCacheThunkAction<void>> =
    createAsyncActionCreator((payload: IHandleErrorPayload) => {
        const {
            error
        } = payload;

        return (dispatch: IItemCacheDispatch) => {
            const {
                errorHandler
            } = dispatch(readConfiguration({
                errorHandler: errorHandlerFacet
            }));

            if (errorHandler) {
                errorHandler(error);
            } else {
                window.setTimeout(() => {
                    throw error;
                }, 0);
            }
        };
    });
